if (!customElements.get('countdown-timer')) {
  class Countdown extends HTMLElement {
    constructor() {
      super();

      const isMock = this.getAttribute('data-enable-mock-timer') === 'true';

      if (isMock) {
        const mockDays = Number(this.getAttribute('data-mock-days')) || 2;
        const mockHours = Number(this.getAttribute('data-mock-hours')) || 3;
        this.countdownDate = new Date(
          Date.now() + (mockDays * 24 + mockHours) * 60 * 60 * 1000
        );
      } else {
        const date = this.getAttribute('data-date');
        const time = this.getAttribute('data-time');
        const safeTime = time && time.length === 5 ? `${time}:00` : (time || '00:00:00');
        this.countdownDate = new Date(`${date}T${safeTime}`);
      }

      this.completedCountdown = this.getAttribute('data-completed');
      this.countdown = this.querySelector('.countdown__main');
      this.countdownHeading = this.querySelector('.countdown__end-info');
      this.daysEl = this.querySelector('.countdown__block-days');
      this.hoursEl = this.querySelector('.countdown__block-hours');
      this.minutesEl = this.querySelector('.countdown__block-minutes');
      this.secondsEl = this.querySelector('.countdown__block-seconds');
      this.section = this.closest('.countdown-section');

      if (this.daysEl) this.daysEl.textContent = '';
      if (this.hoursEl) this.hoursEl.textContent = '';
      if (this.minutesEl) this.minutesEl.textContent = '';
      if (this.secondsEl) this.secondsEl.textContent = '';

      this.startInterval();
    }

    tick() {
      const now = new Date();
      const distance = this.countdownDate.getTime() - now.getTime();

      if (distance < 0 && this.completedCountdown === 'hide_section') {
        clearInterval(this.interval);
        if (this.section) this.section.style.display = 'none';
        return;
      }

      if (distance < 0 && this.completedCountdown === 'show_text') {
        clearInterval(this.interval);
        if (this.countdown) this.countdown.style.display = 'none';
        if (this.countdownHeading) this.countdownHeading.style.display = 'flex';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    startInterval() {
      clearInterval(this.interval);
      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }

  customElements.define('countdown-timer', Countdown);
}
